import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Form, Input } from "semantic-ui-react";
import * as yup from "yup";
import { producaov2 as api } from "../../../../services/apis";

import {
  Container,
  Content, Title
} from "./styles";

import { withRouter } from "react-router-dom";
import swal from "sweetalert";
import Dropzone from "../../../../components/Admin/Dropzone";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../services/auth";
import { getToken } from "../../../../services/auth";

const EditarConsultor = (props) => {
  const id = props.match.params.id;
  const [loading, setLoading] = useState(false);
  const [selectedFileFoto, setSelectedFileFoto] = useState("");
  const [selectedFileFotoMobile, setSelectedFileFotoMobile] = useState("");
  const[data,setData]= useState({
    id: props.match.params.id,
    url: "",
    url_image: "",
    url_image_mobile: "",
    alt_image: "",
    title_campaign: "",
    clicks: "",
    active: 0,
    data_sys: "",
  })

  useEffect(() => {
      loadAuth();
  }, []);
  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
    loadCampaign();
  };

  const loadCampaign = useCallback(
    async () => {
      setLoading(true);

      try {

        const response = await api.get(`/admin/campaign/${id}`, {
          headers: {
            access_token: `voitto-token ${getToken()}`,
          }
          }
        );
        console.log(response);
        setData(response.data);
        setSelectedFileFoto(response.data.url_image)
        setSelectedFileFotoMobile(response.data.url_image_mobile)
        // await systemLogs(`/campaign`, `Listou a campanha`);
        setLoading(false);
      } catch (err) {
        swal(`Não foi possível carregar os cursos`, err, "error");
        setLoading(false);
      }
    },
    []
  );




  const uploadImageFoto = async ({isMobile}) => {
    try {
      const inputData = new FormData();


      if(isMobile){
        inputData.append("file", selectedFileFotoMobile);
        inputData.append("name", selectedFileFotoMobile.name);
        inputData.append("path", "campaign/upload-admin");
      }else {
        inputData.append("file", selectedFileFoto);
        inputData.append("name", selectedFileFoto.name);
        inputData.append("path", "campaign/upload-admin");
      }

      const response = await api.post("/upload", inputData);
      const { url } = response.data;
      
      if(isMobile){
        setData({ ...data, url_image_mobile: url });

      }else{
        setData({ ...data, url_image: url });

      }


      toast.success("A operação foi concluida com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      toast.error("A operação falhou, verifique o arquivo e tente novamente", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };
  const update = async () => {
    // const consultorValidation = await yup.object().shape({
    //   nome: yup
    //     .string("Necessário que informe o nome do consultor")
    //     .required("Necessário que informe o nome do consultor"),
    //   curriculo: yup
    //     .string("Necessário que informe o curriculo")
    //     .required("Necessário que informe o curriculo"),
    //   seg: yup
    //     .string("Necessário que informe o segmento")
    //     .required("Necessário que informe o segmento"),
    //   sexo: yup
    //     .string("Necessário que informe o sexo")
    //     .required("Necessário que informe o sexo"),
    // });

    try {
      // await consultorValidation.validate(data, { abortEarly: true });
      
      await api.put(`/admin/campaign/${id}`,{
        headers: {
          access_token: `voitto-token ${getToken()}`,
        }
        }, data);

      // await systemLogs("consultor", `editou o consultor de id=${id}`);

      props.history.push("/admin/campaign", data);
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }

      // swal("Não foi possível salvar o consultor", err, "").then(() =>
      //   props.history.push("/admin/consultores")
      // );
    }
  };

  if(!loading) {
    return (
      <>
        <Container>
          <AdminMenu />
  
          <Content>
            <Title>Editar Campanha</Title>
  
            <Form>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="ID:"
                  placeholder="id"
                  disabled
                  value={data.id}
                />
              </Form.Group>
              {console.log(data)}
              <Form.Group widths="equal">

                <Form.Field
                  control={Input}
                  label="Status: (checked: ativo | unchecked: inativo) "
                  placeholder="status: 1 ativo 0 Inativo"
                  style={{
                    width: "fit-content",
                    marginLeft: 0
                  }}
                  type="checkbox"
                  checked={data.active}
                  value={data.active}
                  onChange={(e) => {
                    console.log("here")
                    setData({ ...data, active: !data.active });
                  }}
                />

              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Title:"
                  placeholder="Titulo da campanha..."
                  value={data.title_campaign}
                  onChange={(e) => {
                    setData({ ...data, title_campaign: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="url:"
                  placeholder="Url da campanha"
                  value={data.url}
                  onChange={(e) => {
                    setData({ ...data, url: e.target.value });
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Texto descritivo da Imagem:"
                  placeholder="Descreva a imagem"
                  value={data.alt_image}
                  onChange={(e) => {
                    setData({ ...data, alt_image: e.target.value});
                  }}
                />
              </Form.Group>
              <Form.Group>
                <Form.Field>
                  <label>imagem Desktop:</label>
                  <Dropzone onFileUploaded={setSelectedFileFoto} selectFile={selectedFileFoto}/>
                </Form.Field>
              </Form.Group>
              <Form.Field>
                <Button color="primary" onClick={() => uploadImageFoto(false)}>
                  Subir imagem
                </Button>
              </Form.Field>
              <Form.Group>
                <Form.Field>
                  <label>imagem Mobile:</label>
                  <Dropzone onFileUploaded={setSelectedFileFotoMobile} selectFile={selectedFileFotoMobile}/>
                </Form.Field>
              </Form.Group>
              <Form.Field>
                <Button color="primary" onClick={() => uploadImageFoto(true)}>
                  Subir imagem
                </Button>
              </Form.Field>
              <Form.Group>
                <Form.Field control={Button} onClick={() => update()}>
                  Salvar
                </Form.Field>
              </Form.Group>
            </Form>
          </Content>
        </Container>
      </>
    );
  }
  return<></>;
};

export default withRouter(EditarConsultor);
